import { Item as Root } from './Item'
import { Header } from './Header/Header'
import { Avatar } from './Avatar/Avatar'
import { Actor } from './Actor/Actor'
import { ControlGroup } from './ControlGroup/ControlGroup'
import { ControlGroupBox } from './ControlGroup/ControlGroupBox'
import { Control } from './Control/Control'
import { Body } from './Body/Body'
import { Footer } from './Footer/Footer'
import { Reactions } from './Reactions/Reactions'

export const Item = {
  Root,
  Header,
  Avatar,
  Actor,
  ControlGroup,
  ControlGroupBox,
  Control,
  Body,
  Footer,
  Reactions,
}
